import { UserOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal } from "antd";
import React from "react";
import { authenticatedUserApi } from "api/authenticated-user-api";

/**
 * A modal representing the first of two steps in the Forgot Password process.
 * It consists of a form that collects the user's email address.
 *
 * Props:
 *  callback - A function that will handle the form submission. The single
 *  argument for callback will be the form data object: {email}. The callback
 *  is expected to send an email to the user with a one-time token for
 * resetting their password.
 */
export default function ForgotPasswordModal1({ callback, openLogin }) {
  return (
    <Modal
      title="Forgot Password - Step 1/2"
      className="login-modal"
      visible={true}
      closable={false}
      footer={null}
    >
      <Form
        initialValues={{
          remember: true,
        }}
        onFinish={callback}
      >
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              message: "Please input your Email!",
            },
          ]}
        >
          <Input prefix={<UserOutlined />} placeholder="Email" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Send email with one-time code
          </Button>
          <Button type="link" onClick={openLogin}>
            Return to Login
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
